import { Box, ContentBlock, Stack } from 'braid-design-system';

import { FeaturePromoBlock } from 'src/components/FeaturePromoBlock/FeaturePromoBlock';
import Image1 from 'src/images/products/SEEK Optimised Apply-1.png';
import Image2 from 'src/images/products/SEEK Optimised Apply-2.png';
import Image3 from 'src/images/products/SEEK Optimised Apply-3.png';
import Image4 from 'src/images/products/SEEK Optimised Apply-4.png';
import Image5 from 'src/images/products/SEEK Optimised Apply-5.png';

import { SolutionsWrapper } from '../../components/SolutionsWrapper';

export const OptimisedApply = () => (
  <SolutionsWrapper page="SEEK Optimised Apply">
    <ContentBlock>
      <Box paddingX={['gutter', 'none']} paddingY={['none', 'xlarge']}>
        <Stack space={['xlarge', 'xxlarge']} dividers="regular">
          <FeaturePromoBlock
            title="Get to the right candidates faster"
            text="Drive selection efficiency by using screening questions to ensure the right candidates apply for your role."
            image={{
              url: Image1,
              height: 'tall',
            }}
          />
          <FeaturePromoBlock
            title="Benefit from a smoother application review process"
            text="Automatically receive applications into your software, allowing you to assess potential candidates promptly."
            image={{
              url: Image2,
              height: 'tall',
            }}
            reverse
          />
          <FeaturePromoBlock
            title="Identify the right candidates faster"
            text="Easily focus in on the skills, education and work history you're looking for in your preferred candidate’s SEEK Profile."
            image={{
              url: Image3,
              height: 'tall',
            }}
          />
          <FeaturePromoBlock
            title="Promote your brand consistently"
            text="For branded advertisers, the branded apply form helps to give candidates a consistent experience with your brand across their whole journey on SEEK."
            reverse
            image={{
              url: Image4,
              height: 'tall',
            }}
          />
          <FeaturePromoBlock
            title="Make applying more convenient for candidates"
            text="SEEK’s mobile optimised apply form means you can allow allows candidates to easily apply via the mobile app."
            image={{
              url: Image5,
              height: 'tall',
            }}
          />
        </Stack>
      </Box>
    </ContentBlock>
  </SolutionsWrapper>
);
